
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import '@/styles/index.scss' // global css

import Vue from 'vue'
import Element from 'element-ui'
import App from './App'

import store from './store'
import i18n from './lang' // Internationalization
import '@/icons' // icon
import '@/permission' // permission control

import router from './router'
import stringExtend from '@/utils/stringExtend'
import './dialogDrag.js';
import MaskedInput from 'vue-text-mask'

Vue.use(Element, {
  size: 'mini', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.component('masked-input', MaskedInput);

Vue.use(stringExtend)


// 扩展$t方法以支持默认值
const originalT = Vue.prototype.$t
Vue.prototype.$t = function(key, secondParam) {
  let translated
  if (typeof secondParam === 'object') {
    // 如果第二个参数是对象，认为是插值values
    translated = originalT.call(this, key, secondParam)
  } else {
    translated = originalT.call(this, key)
  }
  // 如果翻译结果等于key，且有默认值，则返回默认值
  if (translated === key && secondParam !== undefined && typeof secondParam !== 'object') {
    return secondParam
  }
  return translated
}


Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js